<template>
  <div class="d-flex align-center">
    <div>
      <v-select background-color="kbWhite"
                color="kbDarkBlueText"
                :items="hours"
                item-text="text"
                item-value="value"
                :label="$t('general.pickAnHour')"
                :rules="[rules.required]"
                return-object
                solo
                v-model="localHour" />
    </div>

    <div class="mx-2 d-flex align-self-stretch">
      <span class="kbDarkBlueText--text d-block text-subtitle-1 font-weight-medium pt-3">
        :
      </span>
    </div>

    <div>
      <v-select background-color="kbWhite"
                color="kbDarkBlueText"
                :items="minutes"
                item-text="text"
                item-value="value"
                :label="$t('general.pickMinutes')"
                :rules="[rules.required]"
                return-object
                solo
                v-model="localMinute" />
    </div>
  </div>
</template>

<script>
import rules from '@/libs/rules'
export default {
  computed: {
    hours () {
      const hours = []
      for (let i = 0; i < 24; i++) {
        if (i < 10) {
          hours.push({ text: `0${i}`, value: i })
        } else {
          hours.push({ text: i.toString(), value: i })
        }
      }
      return hours
    },
    localHour: {
      get () {
        return this.hour
      },
      set (value) {
        if (value) {
          this.$emit('onHourChange', value)
        }
      }
    },
    localMinute: {
      get () {
        return this.minute
      },
      set (value) {
        if (value) {
          this.$emit('onMinuteChange', value)
        }
      }
    },
    minutes () {
      const minutes = []
      for (let i = 0; i < 60; i++) {
        if (i < 10) {
          minutes.push({ text: `0${i}`, value: i })
        } else {
          minutes.push({ text: i.toString(), value: i })
        }
      }
      return minutes
    }
  },
  data () {
    return {
      rules
    }
  },
  props: {
    hour: {
      type: Number,
      default: 0
    },
    minute: {
      type: Number,
      default: 0
    }
  }
}
</script>
